// @ts-nocheck
import { useUiStore } from "src/components/main/uiStore";
import { useEffect, useMemo, useState } from "react";
import { truckInventoryList } from "src/components/common/truckInventoryList";
import { AsyncFormSelect, SelectOption } from "src/components/common/AsyncSelect";
import { useAuthStore } from "src/components/main/authStore";
import { myAxios, MyDate} from "src/components/common/functions";
import { Form, Link } from "react-router-dom";

const sortQTYZeroLast = arr => arr.reduce((acc, ele) => ele.qty !== 0?[ele, ...acc]:[...acc, ele], []);
const buildDefaultInventory = vehicleId => ({
    vehicleId: vehicleId || "",
    truckNumber: "",
    content: [],
    checkList: Array(list.length).fill(false)
});
const normalizeVehicleInventory = (vehicleDataStr, fallbackVehicleId = "") => {
    if(!vehicleDataStr) return buildDefaultInventory(fallbackVehicleId);
    try{
        const parsed = JSON.parse(vehicleDataStr);
        return {
            ...buildDefaultInventory(parsed?.vehicleId || fallbackVehicleId),
            ...parsed,
            vehicleId: parsed?.vehicleId || fallbackVehicleId,
            content: Array.isArray(parsed?.content) ? parsed.content : [],
            checkList: Array.isArray(parsed?.checkList) && parsed.checkList.length === list.length
                ? parsed.checkList
                : Array(list.length).fill(false)
        };
    }catch{
        return buildDefaultInventory(fallbackVehicleId);
    }
};
const sectionCardStyle = {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: "1px solid #dbe3ef",
    borderRadius: 16,
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.06)"
};
const sectionTitleStyle = {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "#0f172a"
};
const subtleTextStyle = {
    color: "#64748b",
    fontSize: ".92rem"
};
const radioCardStyle = isActive => ({
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 16px",
    borderRadius: 12,
    border: `1px solid ${isActive ? "#0d6efd" : "#dbe3ef"}`,
    background: isActive ? "#eff6ff" : "#ffffff",
    cursor: "pointer",
    minWidth: 140
});
const infoBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: 999,
    background: "#e0f2fe",
    color: "#0369a1",
    fontSize: ".8rem",
    fontWeight: 700
};
const listRowStyle = {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    background: "#ffffff"
};
const checkboxStyle = {
    width: 22,
    height: 22,
    flexShrink: 0
};
const list = [
    <><strong>Cleanliness/Damage/Missing items</strong> (Interior/Exterior)</>, 
    <><strong>Unusual Noise or Occurrence</strong> (During Operation)</>, 
    <><strong>Leaks/Fluid Levels</strong> (Visually Check for any leaks/check) oil/coolant/hydraulic/brake/windshield wiper fluid…pop hood, look under vehicle</>, 
    <><strong>Batteries</strong> (Damage/cleanliness/security)</>, 
    <><strong>Instrument Gauges</strong> (fuel/hydraulic/battery)</>, 
    <><strong>*Oil sight glasses for Hydrovac Vehicles in proper operating range on water pump & blower*</strong></>, 
    <><strong>Safety Devices</strong> (beacon lights/horn/warning devices/sirens/mirrors/seat belts)</>, 
    <><strong>Safety Equipment</strong> (Fire extinguisher/ eyewash/hazard triangle, vehicle jack and accessories)</>, 
    <><strong>Windshield</strong> (condition/wipers)</>, 
    <><strong>Air Conditioning/Heater</strong> (functioning)</>, 
    <><strong>Radio</strong> (functioning)</>, 
    <><strong>Lights/Brights/Brake lights</strong> (Proper operation)</>, 
    <><strong>Tires</strong> (proper inflation/damage/tread wear): <strong>*notify if below 1.6 mm*</strong></>, 
    <><strong>Wheel Chocks</strong> (verify that the vehicle you are driving has a pair of serviceable chocks prior to departure)</>
];
//--------------------------------------------------------------------------------------------
export default function VehicleForm({
    preOrPost, 
    closeIt, 
    /*---- assignment ------------------------------------------------*/
    assignmentId, 
    userName, 
    isDriverDefault, 
    vehicleId, 
    vehicleName, 
    vehicleDataStr
    /*-------------------------------------------------------------*/
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const user = useAuthStore(state => state.user);
    const [isDriver, setIsDriver] = useState(isDriverDefault);
    const [selectedTruck, setSelectedTruck] = useState<SelectOption | null>(
        vehicleId || vehicleName
            ? {
                value: vehicleId ?? "",
                label: vehicleName || vehicleId || ""
            }
            : null
    );
    const  curVehicleId = selectedTruck?.value ?? "";
    const parsedVehicleData = useMemo(
        () => normalizeVehicleInventory(vehicleDataStr, curVehicleId || vehicleId || ""),
        [vehicleDataStr, curVehicleId, vehicleId]
    );
    const [inventory, setInventory] = useState(() => parsedVehicleData);
    const base = inventory.content.filter(item => item.qty).length;
    const updateInventoryValue = (itemIndex, value) => {
        setInventory(inventory => ({
            ...inventory,
            content: [
                ...inventory.content.slice(0, itemIndex),
                {
                    ...inventory.content[itemIndex],
                    value
                },
                ...inventory.content.slice(itemIndex + 1)
            ]
        }));
    };
    const getInventoryDelta = item => {
        const currentValue = window.parseInt(item.value || item.qty);
        return currentValue - item.qty;
    };
    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        e.preventDefault();
        if(isDriver === "yes" && inventory.checkList.some(v => v === false)){
            window.alert("Please submit a vehicle damage report after submit this form.");
        }
        const formData = new FormData(e.currentTarget);
        //---------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios({ fileName: "assignments/vehicleForm.php", formData: formData });
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------
        closeIt();
    }
    useEffect(() => {
        if(vehicleDataStr && parsedVehicleData.vehicleId === curVehicleId){
            setInventory(parsedVehicleData);
        }else{
            setInventory({
                ...buildDefaultInventory(curVehicleId),
                content: sortQTYZeroLast(truckInventoryList[curVehicleId] || []),
            });
        }
    },[preOrPost, vehicleDataStr, curVehicleId, parsedVehicleData]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form onSubmit={handleFormSubmit} className = "pb-3">
            <input type = "hidden" name = "id" value = {assignmentId}/>
            <input type = "hidden" name = "preOrPost" value = {preOrPost}/>
            <input type = "hidden" name = "vehicleData" value = {isDriver === "yes" ? JSON.stringify(inventory) : ""}/>
            <div className = "my-4 p-4">
                <div className = "d-flex flex-wrap justify-content-between align-items-start gap-3">
                    <div>
                        <h3 className="mb-2">VEHICLE INSPECTION FORM</h3>
                        <div style = {subtleTextStyle}>
                            Complete the driver check, confirm truck inventory, and review inspection criteria before submitting.
                        </div>
                    </div>
                    {vehicleDataStr?
                    <div style = {infoBadgeStyle}>
                        Submitted {parsedVehicleData.submitDate} {parsedVehicleData.submitTime}
                    </div>
                    :null}
                </div>
            </div>
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Driver Confirmation</div>
                <div className = "mt-1 mb-3" style = {subtleTextStyle}>
                    Confirm whether you are the {preOrPost}-work driver for this assignment.
                </div>
                <div className = "d-flex flex-wrap gap-3">
                    <label htmlFor = {`isDriverYes`} style = {radioCardStyle(isDriver === "yes")}>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`isDriverYes`}
                            name = {`isDriver`}
                            checked = {isDriver === "yes"}
                            value = "yes"
                            onChange = {e => {
                                setIsDriver(e.currentTarget.value);
                            }}
                            style = {checkboxStyle}
                        />
                        <span>
                            <strong>Yes</strong>
                            <span className = "d-block" style = {subtleTextStyle}>I am driving the vehicle.</span>
                        </span>
                    </label>
                    <label htmlFor = {`isDriverNo`} style = {radioCardStyle(isDriver === "no")}>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`isDriverNo`}
                            name = {`isDriver`}
                            checked = {isDriver === "no"}
                            value = "no"
                            onChange = {e => {
                                setIsDriver(e.currentTarget.value);
                            }}
                            style = {checkboxStyle}
                        />
                        <span>
                            <strong>No</strong>
                            <span className = "d-block" style = {subtleTextStyle}>No truck inspection required.</span>
                        </span>
                    </label>
                </div>
            </div>
            {isDriver === "yes"?<>
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Truck Selection</div>
                <div className = "mt-1 mb-3" style = {subtleTextStyle}>
                    Search for the truck to load the related inventory and inspection checklist.
                </div>
                <div className = "d-flex flex-column flex-md-row align-items-md-center gap-3">
                    <label
                        htmlFor = {`vehicleId`}
                        className = "fw-bold mb-0"
                        style = {{minWidth: 130}}
                    >
                        Truck Number
                    </label>
                    <AsyncFormSelect
                        className = "flex-grow-1"
                        required
                        inputId = {`vehicleId`}
                        name = "vehicleId"
                        placeholder = "Search truck..."
                        fileName = "common/searchTruck.php"
                        value = {selectedTruck}
                        onChange = {next => setSelectedTruck((next as SelectOption) ?? null)}
                    />
                </div>
                {curVehicleId?
                <div className = "mt-3">
                    <span style = {infoBadgeStyle}>Selected truck: {selectedTruck?.label || curVehicleId}</span>
                </div>
                :null}
            </div>
            <div>
                {inventory.content.length?
                <div className = "p-4 mb-3" style = {sectionCardStyle}>
                    <div className = "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                        <div style = {sectionTitleStyle}>Inventory Count</div>
                        <span style = {infoBadgeStyle}>{base} required items</span>
                    </div>
                    <div className = "d-flex flex-column gap-2">
                        {inventory.content.slice(0, base).map((item, itemIndex) => {
                            const delta = getInventoryDelta(item);
                            return (
                                <div key = {itemIndex} className = "d-flex flex-column flex-md-row align-items-md-center gap-3 p-3" style = {listRowStyle}>
                                    <label className = "mb-0 flex-grow-1" htmlFor = {"inventory item " + itemIndex}>
                                        <strong>{item.title}</strong>
                                        <span className = "ms-2 text-info">Expected: {item.qty}</span>
                                    </label>
                                    <input
                                        type = "number"
                                        required
                                        step = {1}
                                        min = {0}
                                        style = {{maxWidth: 120}}
                                        className = "form-control"
                                        id = {"inventory item " + itemIndex}
                                        value = {inventory.content[itemIndex].value || ""}
                                        onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                                        onBlur = {e => {
                                            let value = e.currentTarget.value;
                                            while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                            updateInventoryValue(itemIndex, value);
                                        }}
                                        onChange = {e => {
                                            updateInventoryValue(itemIndex, e.currentTarget.value);
                                        }}
                                    />
                                    <span className = {`fw-bold text-nowrap ${delta > 0 ? "text-success" : delta < 0 ? "text-danger" : "text-body-secondary"}`}>
                                        {delta > 0 ? `+${delta}` : delta}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                    {inventory.content.slice(base).length?
                    <details className = "mt-3">
                        <summary className = "fw-bold text-success">Extra List</summary>
                        <div className = "d-flex flex-column gap-2 mt-3">
                            {inventory.content.slice(base).map((item, itemIndex) => {
                                const actualIndex = itemIndex + base;
                                const delta = getInventoryDelta(inventory.content[actualIndex]);
                                return (
                                    <div key = {actualIndex} className = "d-flex flex-column flex-md-row align-items-md-center gap-3 p-3" style = {listRowStyle}>
                                        <label className = "mb-0 flex-grow-1" htmlFor = {"inventory item " + actualIndex}>
                                            <strong>{item.title}</strong>
                                            <span className = "ms-2 text-info">Expected: {item.qty}</span>
                                        </label>
                                        <input
                                            type = "number"
                                            step = {1}
                                            min = {0}
                                            style = {{maxWidth: 120}}
                                            className = "form-control"
                                            id = {"inventory item " + actualIndex}
                                            value = {inventory.content[actualIndex].value || ""}
                                            onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                                            onBlur = {e => {
                                                let value = e.currentTarget.value;
                                                while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                                updateInventoryValue(actualIndex, value);
                                            }}
                                            onChange = {e => {
                                                updateInventoryValue(actualIndex, e.currentTarget.value);
                                            }}
                                        />
                                        <span className = {`fw-bold text-nowrap ${delta > 0 ? "text-success" : delta < 0 ? "text-danger" : "text-body-secondary"}`}>
                                            {delta > 0 ? `+${delta}` : delta}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </details>
                    :null}
                </div>
                :null}
                {curVehicleId?
                <div className = "p-4 mb-3" style = {sectionCardStyle}>
                    <div className = "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                        <div style = {sectionTitleStyle}>Inspection Criteria</div>
                        <span style = {infoBadgeStyle}>
                            {inventory.checkList.filter(Boolean).length}/{list.length} complete
                        </span>
                    </div>
                    <div className = "d-flex flex-column gap-2">
                        {list.map((item, itemIndex) =>
                        <label key = {itemIndex} className = "d-flex align-items-start gap-3 p-3 mb-0" style = {listRowStyle} htmlFor = {"item " + itemIndex}>
                            <input
                                type = "checkbox"
                                style = {{...checkboxStyle, marginTop: 2}}
                                id = {"item " + itemIndex}
                                checked = {inventory.checkList[itemIndex]}
                                onChange = {e => {
                                    const checked = e.currentTarget.checked;
                                    setInventory(inventory => ({...inventory,
                                        checkList: [
                                            ...inventory.checkList.slice(0, itemIndex), 
                                            checked,
                                            ...inventory.checkList.slice(itemIndex + 1)
                                        ]
                                    }));
                                }}
                            />
                            <span>{item}</span>
                        </label>)}
                    </div>
                </div>
                :null}
            </div>
            </>:null}
            <div className = "p-4 mb-3" style = {sectionCardStyle}>
                <div style = {sectionTitleStyle}>Submission Details</div>
                <div className = "row g-3 mt-1">
                    <div className = "col-12 col-md-7">
                        <label className = "required-field fw-bold mb-2 d-block">Member name</label>
                        <input
                            type = "text" 
                            className = "form-control" 
                            disabled
                            name = "memberName"
                            value = {userName || user.userName} 
                        />
                    </div>
                    <div className = "col-12 col-md-5">
                        <label className = "required-field fw-bold mb-2 d-block">Date</label>
                        <input
                            type = "text"
                            className = "form-control"
                            disabled
                            name = "submitDate" 
                            value = {(new MyDate()).s()}
                        />
                    </div>
                </div>
            </div>
            <div className="pt-2 d-flex flex-wrap gap-2">
                <button type="submit" className="btn btn-primary px-4">
                    Submit
                </button>
                <Link to=".." relative="path" className="btn btn-outline-secondary ms-sm-auto">
                    Back
                </Link>
            </div>
        </Form>
    )    
}
